import React from 'react';
import ImageZoom from './imagezoom';
import './styles/TopSection.css';
import './styles/TopSection.mobile.css';

interface ProductVariant {
  id: string;
  size: string;
  price: number;
  pricePerMeter: number;
  rollLength: number;
  variantImage?: string;
  variantImages?: string[];
}

interface TopSectionProps {
  // Product Images Data
  mainImage: string;
  thumbnailImages: string[];
  productName: string;
  
  // Product Info Data
  productId: string;
  title: string;
  basePrice: number;
  pricePerMeter: number;
  variants: ProductVariant[];
  hierarchicalVariants?: any[];
  variantHierarchy?: string[];
  mainProductImage: string;
  compareAtPrice?: number;
  quantity?: number;
  // Event Handlers
  onAddToCart: (variantId: string, quantity: number) => void;
  onBuyNow: (variantId: string, quantity: number) => void;
  onVariantChange?: (variant: any) => void;
}

const TopSection: React.FC<TopSectionProps> = ({
  mainImage,
  thumbnailImages,
  productName,
  productId,
  title,
  basePrice,
  pricePerMeter,
  variants,
  hierarchicalVariants,
  variantHierarchy,
  mainProductImage,
  compareAtPrice,
  onAddToCart,
  onBuyNow,
  onVariantChange,
  quantity
}) => {
  return (
    <ImageZoom
      mainImage={mainImage}
      thumbnailImages={thumbnailImages}
      productName={productName}
      productId={productId}
      title={title}
      basePrice={basePrice}
      pricePerMeter={pricePerMeter}
      variants={variants}
      hierarchicalVariants={hierarchicalVariants}
      variantHierarchy={variantHierarchy}
      mainProductImage={mainProductImage}
      compareAtPrice={compareAtPrice}
      onAddToCart={onAddToCart}
      onBuyNow={onBuyNow}
      onVariantChange={onVariantChange}
      quantity={quantity}
    />
  );
};

export default TopSection;

